if (!customElements.get('coreeky-gallery')) customElements.define('coreeky-gallery', class extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready) return;
    this.dataset.ready = 'true';
    const images = JSON.parse(this.querySelector('.ck-gallery-data').textContent);
    const main = this.querySelector('.ck-main-image');
    const rail = this.querySelector('.ck-thumbnails');
    const dialog = this.querySelector('dialog');
    const select = index => {
      main.removeAttribute('srcset'); main.removeAttribute('sizes');
      main.src = images[index].src; main.alt = images[index].alt;
      this.dataset.selectedIndex = index;
      [...rail.children].forEach((button,i)=>button.setAttribute('aria-current',String(i===index)));
      this.querySelector('.ck-gallery-status').textContent = `Image ${index+1} of ${images.length}`;
    };
    images.forEach((image,index)=>{
      const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',`Show product image ${index+1}`);
      const img=document.createElement('img');img.src=image.src;img.alt='';img.width=80;img.height=80;img.loading='lazy';button.append(img);
      button.addEventListener('click',()=>select(index));rail.append(button);
    });
    if(images.length)select(0);
    this.querySelector('.ck-zoom').addEventListener('click',()=>{const img=dialog.querySelector('img');img.src=main.src;img.alt=main.alt;dialog.showModal()});
    this.querySelector('.ck-close').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',e=>{if(e.target===dialog)dialog.close()});
  }
});
